import { render, staticRenderFns } from "./ExtensionHeader.vue?vue&type=template&id=2adabc79"
import script from "./ExtensionHeader.vue?vue&type=script&lang=js"
export * from "./ExtensionHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports